module.exports = __webpack_public_path__ + "img/qeppanel.13397c96.png";